import React from "react";

const NetworkImplementation = () => {
    return (
        <div className='page-content'>
            <div className='page-banner-content mb-5'>
                <div className='container'>
                    <div className='section-title-div wow animate__animated animate__fadeInDown'>
                        <h1>
                            Network
                            <span className='text-primary'> Implementation</span>
                        </h1>
                        <p>
                            We ensure reliable, secure, and high-performance connectivity across your organization—whether you're building from scratch, scaling, or migrating. With a focus on speed, scalability, and minimal downtime, our solutions are engineered to support seamless operations and future-ready growth.
                        </p>
                    </div>
                </div>

            </div>

            <div className='page-banner mb-5'>
                <div className='container'>
                    <div className='page-img wow animate__animated animate__zoomIn'>
                        <img
                            src="/assets/images/ni-banner.png"
                            alt="img"
                            className="img-fluid w-100"
                        />
                    </div>
                </div>
            </div>

            <div className='service-feature'>
                <div className='container'>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className='col-md-6 mb-5'>
                                <div className='sf-card h-100 sf-round1 wow animate__animated animate__zoomIn'>
                                    <h4>Network Architecture consulting</h4>
                                    <p>
                                        End-to-end network architecture consulting (including HLD, LLD, BOM, Procurement, and Project Management).
                                    </p>
                                </div>
                            </div>

                            <div className='col-md-6 mb-5'>
                                <div className='sf-card h-100 sf-round2 wow animate__animated animate__zoomIn'>
                                    <h4>Rack design &
                                        Implementation</h4>
                                    <p>
                                        Comprehensive onsite services including racking, stacking, tagging, structured cabling, and powering of equipment.
                                    </p>
                                </div>
                            </div>

                            <div className='col-md-6 mb-5'>
                                <div className='sf-card h-100 sf-round3 wow animate__animated animate__zoomIn'>
                                    <h4>Infrastructure deployment and management</h4>
                                    <p>
                                        Install, manage and configure Network devices (Routers, Switches, Servers, Firewalls, Load Balancers, Wireless LAN).
                                    </p>
                                </div>
                            </div>

                            <div className='col-md-6 mb-5'>
                                <div className='sf-card h-100 sf-round4 wow animate__animated animate__zoomIn'>
                                    <h4>Data Center Modernization & Migration</h4>
                                    <p>
                                        Disruption-free migration of workloads from on-premise environments and VMware platforms to public, private, or hybrid cloud infrastructures.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div className='customer-approach-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='section-title-div wow animate__animated animate__fadeInDown'>
                                <h1>
                                    Customer Centric
                                    <span className='text-primary'>Approach</span>
                                </h1>
                            </div>
                            <div className='row row-gap-3'>
                                <div className='col-md-7 order-2 order-sm-2 order-md-1'>
                                    <div className='cas-collapes  wow animate__animated animate__fadeInLeft'>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading1">
                                                    <button className="accordion-button" type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapse1" aria-expanded="true"
                                                            aria-controls="collapse1">
                                                        24/7 Support
                                                    </button>
                                                </h2>
                                                <div id="collapse1" className="accordion-collapse collapse show"
                                                     aria-labelledby="heading1" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Dedicated to helping customers achieve their goals and maximize
                                                        the
                                                        value
                                                        of their technology investments, with a strong focus on customer
                                                        satisfaction.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading2">
                                                    <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapse2"
                                                            aria-expanded="false" aria-controls="collapse2">
                                                        Commitment to Customer Success
                                                    </button>
                                                </h2>
                                                <div id="collapse2" className="accordion-collapse collapse"
                                                     aria-labelledby="heading2" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Dedicated to helping customers achieve their goals and maximize
                                                        the
                                                        value
                                                        of their technology investments, with a strong focus on customer
                                                        satisfaction.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading3">
                                                    <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapse3"
                                                            aria-expanded="false" aria-controls="collapse3">
                                                        Security-Focused
                                                    </button>
                                                </h2>
                                                <div id="collapse3" className="accordion-collapse collapse"
                                                     aria-labelledby="heading3" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Dedicated to helping customers achieve their goals and maximize
                                                        the
                                                        value
                                                        of their technology investments, with a strong focus on customer
                                                        satisfaction.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading4">
                                                    <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapse4"
                                                            aria-expanded="false" aria-controls="collapse4">
                                                        Extensive Knowledge Base
                                                    </button>
                                                </h2>
                                                <div id="collapse4" className="accordion-collapse collapse"
                                                     aria-labelledby="heading4" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Dedicated to helping customers achieve their goals and maximize
                                                        the
                                                        value
                                                        of their technology investments, with a strong focus on customer
                                                        satisfaction.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="heading5">
                                                    <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapse5"
                                                            aria-expanded="false" aria-controls="collapse5">
                                                        Flexible Deployment Options
                                                    </button>
                                                </h2>
                                                <div id="collapse5" className="accordion-collapse collapse"
                                                     aria-labelledby="heading5" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        Dedicated to helping customers achieve their goals and maximize
                                                        the
                                                        value
                                                        of their technology investments, with a strong focus on customer
                                                        satisfaction.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-5 order-1 order-sm-1 order-md-2'>
                                    <div className='cas-img  wow animate__animated animate__fadeInRight'>
                                        <img
                                            src="/assets/images/approach-img.png"
                                            alt="img"
                                            className="img-fluid w-100"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    );
};

export default NetworkImplementation;
